import dayjs from 'dayjs';
import theme from '../../theme';

export const MIN_YEAR = 1776;
export const MAX_YEAR = 2099;
export const MIN_COMPLETE_YEAR = 1000;
export const DEFAULT_MIN_DATE = dayjs(`${MIN_YEAR}-07-04`);
export const DEFAULT_MAX_DATE = dayjs(`${MAX_YEAR}-12-31`);

export const datePickerStyles = (size: 'small' | 'medium') => ({
  lineHeight: '0',
  '& .MuiInputAdornment-positionStart': {
    position: 'absolute',
    right: size === 'medium' ? '-3px' : '-8px',
  },
  '& .endAdornmentContainer': {
    marginTop: '2px',
  },
  '& .endAdornmentContainer .MuiButtonBase-root': {
    padding: size === 'small' ? 0 : undefined,
  },
  '& .MuiFormLabel-root.Mui-focused:not(.Mui-error)': {
    color: theme.palette.customColors.gray[900],
  },
  '& .TextField.MuiBox-root': {
    width: '100%',
  },
  '& .TextField .MuiInputBase-root': {
    padding: size === 'medium' ? '0 0 0 14px' : '0 0 0 12px',
    '.MuiInputBase-input': {
      paddingLeft: '0px !important',
    },
  },
});
